
import { Input } from '@angular/core';

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-view',
  templateUrl: './full-view.component.html',
  styleUrls: ['./full-view.component.css']
})
export class FullViewComponent implements OnInit {

  @Input() name  : string;
  @Input() title : string;

  constructor() { }

  ngOnInit() {}

}
